import React, {useEffect, useState} from 'react';
import Button from '../../BaseComponentWrappers/MotifButton';
import {labels} from '../../../../util/utils';
import EntitiesModalWrapper from '../../EntityCrud/EntitiesModalWrapper';
import {Entity} from '../../../../util/uiconstants';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {useEngagementId} from '../../../../util/customHooks';
import {deleteManageAccount, getAllEngagementManageAccounts} from '../../../../actions/Account/manageaccountsactions';

export default function ManageAccounts(props) {
	const {onClose} = props;
	const [showAccountsModal, setShowAccountsModal] = useState(false);
	const engagementId = useEngagementId();
	const [formattedAccounts, setFormattedAccounts] = useState([]);
	const accounts = useSelector((store) => store?.manageAccounts);
	const handlerOnModalOpen = () => {
		setShowAccountsModal(true);
	};

	useEffect(() => {
		if (accounts?.byId && accounts?.allIds) {
			let formattedAccounts = [];

			// Done this way in order to maintain API sort order
			formattedAccounts = accounts.allIds.map((accountId) => {
				let name = accounts.byId[accountId].accountName;
				return {
					id: accountId,
					name: name
				};
			});

			setFormattedAccounts(formattedAccounts);
		}
	}, [accounts]);

	const handlerOnModalClose = () => {
		setShowAccountsModal(false);
		onClose && onClose();
	};

	return (
		<StyledManageAccounts className="StyledManageAccounts">
			<Button
				variant="text-alt"
				className="manageAccount"
				onClick={handlerOnModalOpen}
				showLabel
				isEllipsed
				buttonLabel={labels.mapAccountsAndDisclosuresManageLabel}
				noOfLines={1}
			/>
			{showAccountsModal && (
				<EntitiesModalWrapper
					engagementId={engagementId}
					isManageEntities
					show={showAccountsModal}
					entityType={Entity.Account}
					setShow={setShowAccountsModal}
					getAllAction={() => {
						return getAllEngagementManageAccounts(
							engagementId,
							{isManageAccounts: true},
							{orderBy: 'AccountName', orderByAscending: true}
						);
					}}
					entities={formattedAccounts}
					deleteAction={(id) => {
						return deleteManageAccount(engagementId, id);
					}}
					onClose={handlerOnModalClose}
					setIsEntityUpdated={props.setIsEntityUpdated}
				/>
			)}
		</StyledManageAccounts>
	);
}

const StyledManageAccounts = styled.section`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;
